export enum AuthResponseType {
  SUCCESS = 'SUCCESS',
  EMAIL_INVALID = 'EMAIL_INVALID',
  PASSWORD_INVALID = 'PASSWORD_INVALID',
  SANDBOX_EXPIRED = 'SANDBOX_EXPIRED',
  TRIAL_EXPIRED = 'TRIAL_EXPIRED',
  LOGIN_DISABLED = 'LOGIN_DISABLED',
  LOGIN_METHOD_DISABLED = 'LOGIN_METHOD_DISABLED',
  ALL_LOGIN_METHODS_DISABLED = 'ALL_LOGIN_METHODS_DISABLED',
  ACCESS_REVOKED = 'ACCESS_REVOKED'
}